// @ts-check

/**
 * Gets the canonical URL from the page's link[rel="canonical"] element.
 *
 * @returns {string | null} The canonical URL href, or null if not found
 */
const getCanonicalUrl = () => {
  const link = document.querySelector('link[rel="canonical"]');
  return link instanceof HTMLLinkElement ? link.href : null;
};

export default getCanonicalUrl;
